import { Input, Button, Icon } from 'loyal-react'
import { Link, withRouter } from 'react-router-dom'
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

const RecoveryBoxSms = ({
  handleChange,
  handleSubmitRegisterSms,
  handleBackToHome,
  isLookingUpContact,
  cellPhone,
  error,
  handleValidate,
  location: { search }
}) => {
  const isValid = cellPhone && cellPhone.length > 0 && cellPhone.length === 15

  const handleKeyPress = (e, element) => {
    let inputIndex = element
    const inputOrder = [
      'cellPhone',
      'btnContinueCellphone'
    ]
    let isDisabled = true

    while (isDisabled) {
      if (inputOrder[inputIndex] === 'btnContinueCellphone') {
        isDisabled = false
      } else {
        let input = document.querySelector(`#${inputOrder[inputIndex]}`)
        if (input.getAttribute('disabled') === null || input.getAttribute('disabled') === undefined) {
          isDisabled = false
        } else {
          inputIndex++
        }
      }
    }

    // eslint-disable-next-line no-unused-expressions
    if (e.key === 'Enter') {
      if (inputIndex) {
        e.target.blur()
        document.querySelector(`#${inputOrder[inputIndex]}`) &&
          document.querySelector(`#${inputOrder[inputIndex]}`).focus()
      }
    }
  }

  return (
    <Fragment>
      <div id='box-login' className={`box-login row pb-4 'd-none`}>
        <div className='col-12 col-md-6 col-lg-4 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5'>
          <div className='row'>
            <div className='col-6 col-md-12 mb-2'>
              <p className='txt-body-sm'>
                <MediaQuery maxWidth={489}>
                  <a
                    id='image-link'
                    className='txt-body-sm pointer'
                    aria-label='Voltar'
                    role='button'
                    href={`/login${search}`}
                  >
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
                <MediaQuery minWidth={490}>
                  <a
                    className='txt-body-sm pointer'
                    aria-label='Voltar'
                    role='button'
                    href={`/login${search}`}
                  >
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
              </p>
            </div>
            <MediaQuery maxWidth={489}>
              <div className='col-6 mb-2 close-login'>
                <p className='txt-body-sm'>
                  <a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}`} className='txt-body-sm d-flex justify-content-end' aria-label='Fechar tela de login' role='button'>
                    <Icon className='icon icon_menu_app_close' />
                  </a>
                </p>
              </div>
            </MediaQuery>
          </div>
          <div className='row'>
            <div className='col-12'>
              <h1 className='h1 login-title color-brand-1 txt-font-body mb-1'>agora confirme seu telefone.
              </h1>
              <div className='row'>
                <Input
                  id='cellPhone'
                  label='Celular'
                  className='col-12 col-md-12 mt-1'
                  mask={['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                  type='text'
                  name='cellPhone'
                  value={cellPhone}
                  onChange={handleChange}
                  onKeyPress={(e) => handleKeyPress(e, 1)}
                  onBlur={({ target: { name, value } }) => handleValidate(name, value)}
                  valid={error ? false : undefined}
                />
              </div>
            </div>
          </div>
          {error ? (
            <div className='col-12 col-md-12 mr-auto mt-2'>
              <div className='row'>
                <span className='message message-error' role='alert'>
                  <small className='txt-subtitle txt-opensans color-error'>{error ? error.message : ''}</small>
                </span>
              </div>
            </div>
          ) : (
            ''
          )}

          <div className='col-12 col-md-12 txt-center mt-2 px-0'>
            <div className='hide-absolute' aria-live='assertive' role='status' aria-atomic='true'>
              {!isValid && 'Por favor, informe seu celular'}
            </div>
            <Button
              id='btnContinueCellphone'
              className='btn btn-sm btn-featured'
              type='button'
              text='Continuar'
              disabled={!isValid || isLookingUpContact}
              loading={isLookingUpContact}
              onClick={handleSubmitRegisterSms}
            />
          </div>
        </div>
      </div>
    </Fragment>
  )
}

RecoveryBoxSms.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmitRegisterSms: PropTypes.func.isRequired,
  handleBackToHome: PropTypes.func.isRequired,
  isLookingUpContact: PropTypes.bool,
  cellPhone: PropTypes.string,
  error: PropTypes.object,
  location: PropTypes.shape({
    search: PropTypes.string
  }),
  handleValidate: PropTypes.func
}

export default withRouter(RecoveryBoxSms)
